import { render, staticRenderFns } from "./RegluvardarShare.vue?vue&type=template&id=c491804a&scoped=true"
import script from "./RegluvardarShare.vue?vue&type=script&lang=js"
export * from "./RegluvardarShare.vue?vue&type=script&lang=js"
import style0 from "./RegluvardarShare.vue?vue&type=style&index=0&id=c491804a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c491804a",
  null
  
)

export default component.exports